import * as React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { AbilityContext } from '../../../../components/Can';
import { ScheduleEntry } from '../../../../domain/ScheduleEntry';
import PublisherTextField from '../PublisherTextField';
import ScheduleSpeakerInput from '../ScheduleSpeakerInput';
import ScheduleTableRowActionsMenu from '../ScheduleTableRowActionsMenu';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../../stores';

interface Props {
    name?: string;
    entry: ScheduleEntry;
    assigned: number[];
    editable?: boolean;
    onEntryUpdate?: (entry: ScheduleEntry) => void;
    onEntryEdit?: (entry: ScheduleEntry) => void;
    onPublisherScheduleHistory?: (entry: ScheduleEntry) => void;
    onEntryAssignmentHistory?: (entry: ScheduleEntry) => void;
    onEntrySendNotification?: (entry: ScheduleEntry) => void;
    onEntryDownload?: (entry: ScheduleEntry) => void;
    onEntryAutoArrange?: (entry: ScheduleEntry) => void;
}

const ScheduleTableMobileSingleRow = observer((props: Props) => {
    const { publisherStore } = useStores();
    const ability = React.useContext(AbilityContext);

    let isEditable = ability.can("manage", "ScheduleEntry");
    if (props.editable !== undefined) {
        isEditable = props.editable;
    }

    const myPublisher = publisherStore.myPublisher;
    const isMyPublisher = myPublisher && (myPublisher.id === props.entry.speakerId || myPublisher.id === props.entry.companionId);
    const isImpromptu = !!props.entry.impromptuId;

    const handleEntryEdit = () => props.onEntryEdit && props.onEntryEdit(props.entry);
    const handlePublisherScheduleHistory = () => props.onPublisherScheduleHistory && props.onPublisherScheduleHistory(props.entry);
    const handleEntryAssignmentHistory = () => props.onEntryAssignmentHistory && props.onEntryAssignmentHistory(props.entry);
    const handleSendNotification = () => props.onEntrySendNotification && props.onEntrySendNotification(props.entry);
    const handleDownloadS89 = () => props.onEntryDownload && props.onEntryDownload(props.entry);
    const handleAutoArrange = () => props.onEntryAutoArrange && props.onEntryAutoArrange(props.entry);

    const backgroundColor = isMyPublisher ? "#2e7d3214" : isImpromptu ? "#c628281c" : undefined
    return (
        <>
            <TableRow style={{ backgroundColor }}>
                <TableCell sx={{ fontWeight: 700, fontSize: '0.80rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {props.name || props.entry.name}
                    <ScheduleTableRowActionsMenu
                        isEditable={isEditable}
                        entry={props.entry}
                        onEdit={props.onEntryEdit ? handleEntryEdit : undefined}
                        onViewPublisherHistory={props.onPublisherScheduleHistory ? handlePublisherScheduleHistory : undefined}
                        onViewAssignmentHistory={props.onEntryAssignmentHistory ? handleEntryAssignmentHistory : undefined}
                        onSendNotification={props.onEntrySendNotification ? handleSendNotification : undefined}
                        onDownload={props.onEntryDownload ? handleDownloadS89 : undefined}
                        onAutoArrange={props.onEntryAutoArrange ? handleAutoArrange : undefined}
                    />
                </TableCell>
            </TableRow>
            <TableRow sx={{ borderBottom: '2px solid rgba(0, 0, 0, 0.1)' }} >
                <TableCell>
                    {isEditable ? (
                        <>
                            <ScheduleSpeakerInput
                                entry={props.entry}
                                editable={isEditable}
                                assigned={props.assigned}
                                onEntryUpdate={props.onEntryUpdate}
                            />

                            {props.entry.companionNeeded &&
                                <PublisherTextField
                                    entry={props.entry}
                                    field="companion"
                                    editable={isEditable}
                                    assigned={props.assigned}
                                    onEntryUpdate={props.onEntryUpdate}
                                />}
                        </>
                    ) : (
                        <>
                            <ScheduleSpeakerInput
                                entry={props.entry}
                                editable={isEditable}
                                assigned={props.assigned}
                                onEntryUpdate={props.onEntryUpdate}
                            />
                            {props.entry.speaker && props.entry.companionNeeded && ' | '}
                            <PublisherTextField
                                entry={props.entry}
                                field="companion"
                                editable={isEditable}
                                assigned={props.assigned}
                                onEntryUpdate={props.onEntryUpdate}
                            />
                        </>
                    )}
                </TableCell>
            </TableRow>

        </>

    );
});

export default ScheduleTableMobileSingleRow;